﻿//use constants everywhere. no typo, 1 source of update
export const pages = {
  login: 'login',
  noBranches: 'no-branches',

  home: 'home',
  quotes: 'quotes',
  quote: 'quote',
  projects: 'projects',
  project: 'project',
  purchaseOrders: 'purchase-orders',
  purchaseOrder: 'purchase-order',
  fabricationJobs: 'fabrication-jobs',
  fabricationJob: 'fabrication-job',
  fabricationPurchaseOrders: 'fabrication-purchase-orders',
  fabricationPurchaseOrder: 'fabrication-purchase-order',
  supportInbox: 'support-inbox',
  clients: 'clients',
  client: 'client',
  settings: 'settings'
};
